import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { Container } from '../ui/Container';
import { SectionHeading } from '../ui/SectionHeading';
const testimonials = [{
  quote: 'Client testimonial — placeholder. A short, genuine quote about clear advice and a practical outcome will sit here once confirmed with the firm.',
  name: 'Client testimonial',
  detail: 'Business client · to be confirmed'
}, {
  quote: 'Client testimonial — placeholder. Feedback about steady guidance through a difficult family or property matter will appear here.',
  name: 'Client testimonial',
  detail: 'Family / property client · to be confirmed'
}, {
  quote: 'Client testimonial — placeholder. A comment on communication, options and value will be added following client approval.',
  name: 'Client testimonial',
  detail: 'Estate / succession client · to be confirmed'
}];
export function Testimonials() {
  return <section className="bg-white py-16 lg:py-24" data-id="element-200">
      <Container data-id="element-201">
        <SectionHeading align="center" eyebrow="What clients say" title="Clear advice, steady guidance, practical outcomes." intro="Clients come to Cullen Macleod when they need clear advice, steady guidance and practical legal solutions." data-id="element-202" />
        <div className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-3" data-id="element-203">
          {testimonials.map((t, i) => <motion.blockquote key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i * 0.08
        }} className="flex flex-col rounded-xl border border-navy/10 bg-cream p-6" data-id="element-204">
              <QuoteIcon className="h-7 w-7 text-brass/40" data-id="element-205" />
              <p className="mt-3 flex-1 text-[0.95rem] leading-relaxed text-ink/75" data-id="element-206">
                {t.quote}
              </p>
              <footer className="mt-5 border-t border-navy/10 pt-4" data-id="element-207">
                <p className="text-sm font-semibold text-navy" data-id="element-208">{t.name}</p>
                <p className="text-xs text-ink/50" data-id="element-209">{t.detail}</p>
              </footer>
            </motion.blockquote>)}
        </div>
      </Container>
    </section>;
}